import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyShoppingCart} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';

class MyShoppingCartPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyShoppingCartPage;
  }

  render() {
    return (
      <MasterLayout>
        <MyShoppingCart params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default MemberZone(MyShoppingCartPage);



// WEBPACK FOOTER //
// ./pages/users/MyShoppingCartPage.jsx